import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  background: #f8fafc;
  padding: clamp(1.25rem, 2vw, 2rem);

  /* Responsive sizing for different desktop resolutions */
  @media (min-width: 1920px) {
    padding: clamp(2rem, 3vw, 2.5rem);
  }

  @media (min-width: 1440px) and (max-width: 1919px) {
    padding: clamp(1.75rem, 2.5vw, 2.25rem);
  }

  @media (min-width: 1366px) and (max-width: 1439px) {
    padding: clamp(1.5rem, 2vw, 2rem);
  }

  @media (min-width: 1280px) and (max-width: 1365px) {
    padding: clamp(1.25rem, 1.75vw, 1.875rem);
  }

  @media (min-width: 1024px) and (max-width: 1279px) {
    padding: clamp(1rem, 1.5vw, 1.75rem);
  }

  @media (max-width: 1023px) {
    padding: clamp(0.875rem, 1.25vw, 1.5rem);
  }
  
  @media (max-width: 768px) {
    padding: clamp(0.75rem, 1vw, 1.25rem);
  }
`;

const ErrorCode = styled.h1`
  font-weight: 700;
  color: #667eea;
  margin: 0;
  line-height: 1;
  font-size: clamp(4.5rem, 8vw, 7.5rem);

  /* Responsive sizing for different desktop resolutions */
  @media (min-width: 1920px) {
    font-size: clamp(7rem, 10vw, 8.5rem);
  }

  @media (min-width: 1440px) and (max-width: 1919px) {
    font-size: clamp(6.5rem, 9vw, 8rem);
  }

  @media (min-width: 1366px) and (max-width: 1439px) {
    font-size: clamp(6rem, 8.5vw, 7.5rem);
  }

  @media (min-width: 1280px) and (max-width: 1365px) {
    font-size: clamp(5.5rem, 8vw, 7rem);
  }

  @media (min-width: 1024px) and (max-width: 1279px) {
    font-size: clamp(5rem, 7.5vw, 6.5rem);
  }

  @media (max-width: 1023px) {
    font-size: clamp(4.5rem, 7vw, 6rem);
  }
  
  @media (max-width: 768px) {
    font-size: clamp(4rem, 6.5vw, 5.5rem);
  }
`;

const ErrorMessage = styled.h2`
  color: #1a202c;
  font-size: clamp(1.125rem, 1.5vw, 1.5rem);
  margin: clamp(1rem, 1.5vw, 1.5rem) 0;

  /* Responsive sizing for different desktop resolutions */
  @media (min-width: 1920px) {
    font-size: clamp(1.375rem, 2vw, 1.75rem);
    margin: clamp(1.25rem, 2vw, 1.75rem) 0;
  }

  @media (min-width: 1440px) and (max-width: 1919px) {
    font-size: clamp(1.25rem, 1.75vw, 1.625rem);
    margin: clamp(1.125rem, 1.75vw, 1.625rem) 0;
  }

  @media (min-width: 1366px) and (max-width: 1439px) {
    font-size: clamp(1.125rem, 1.5vw, 1.5rem);
    margin: clamp(1rem, 1.5vw, 1.5rem) 0;
  }

  @media (min-width: 1280px) and (max-width: 1365px) {
    font-size: clamp(1rem, 1.375vw, 1.375rem);
    margin: clamp(0.875rem, 1.25vw, 1.375rem) 0;
  }

  @media (min-width: 1024px) and (max-width: 1279px) {
    font-size: clamp(0.9375rem, 1.25vw, 1.25rem);
    margin: clamp(0.75rem, 1vw, 1.25rem) 0;
  }

  @media (max-width: 1023px) {
    font-size: clamp(0.875rem, 1.125vw, 1.125rem);
    margin: clamp(0.625rem, 0.875vw, 1rem) 0;
  }
  
  @media (max-width: 768px) {
    font-size: clamp(0.8125rem, 1vw, 1rem);
    margin: clamp(0.5rem, 0.75vw, 0.875rem) 0;
  }
`;

const ErrorDescription = styled.p`
  color: #64748b;
  line-height: 1.6;
  font-size: clamp(0.875rem, 1.125vw, 1rem);
  max-width: clamp(20rem, 30vw, 31.25rem);
  margin: 0 0 clamp(1.375rem, 2vw, 2rem);

  /* Responsive sizing for different desktop resolutions */
  @media (min-width: 1920px) {
    font-size: clamp(1rem, 1.25vw, 1.125rem);
    max-width: clamp(25rem, 35vw, 31.25rem);
    margin: 0 0 clamp(2rem, 2.5vw, 2.5rem);
  }

  @media (min-width: 1440px) and (max-width: 1919px) {
    font-size: clamp(0.9375rem, 1.125vw, 1.0625rem);
    max-width: clamp(23.75rem, 32vw, 30rem);
    margin: 0 0 clamp(1.75rem, 2.25vw, 2.25rem);
  }

  @media (min-width: 1366px) and (max-width: 1439px) {
    font-size: clamp(0.9375rem, 1.125vw, 1.0625rem);
    max-width: clamp(22.5rem, 30vw, 27.5rem);
    margin: 0 0 clamp(1.75rem, 2vw, 2rem);
  }

  @media (min-width: 1280px) and (max-width: 1365px) {
    font-size: clamp(0.875rem, 1vw, 1rem);
    max-width: clamp(21.25rem, 28vw, 26.25rem);
    margin: 0 0 clamp(1.625rem, 1.875vw, 1.875rem);
  }

  @media (min-width: 1024px) and (max-width: 1279px) {
    font-size: clamp(0.875rem, 1vw, 1rem);
    max-width: clamp(20rem, 26vw, 25rem);
    margin: 0 0 clamp(1.5rem, 1.75vw, 1.75rem);
  }

  @media (max-width: 1023px) {
    font-size: clamp(0.8125rem, 0.9375vw, 0.9375rem);
    max-width: clamp(18.75rem, 24vw, 23.75rem);
    margin: 0 0 clamp(1.375rem, 1.5vw, 1.5rem);
  }
  
  @media (max-width: 768px) {
    font-size: clamp(0.75rem, 0.875vw, 0.875rem);
    max-width: clamp(15rem, 20vw, 20rem);
    margin: 0 0 clamp(1.25rem, 1.375vw, 1.375rem);
  }
`;

const HomeLink = styled(Link)`
  display: inline-block;
  background: #667eea;
  color: white;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.2s ease;
  padding: clamp(0.5rem, 1vw, 1rem) clamp(1rem, 2vw, 1.5rem);
  border-radius: clamp(0.375rem, 0.5vw, 0.5rem);
  font-size: clamp(0.875rem, 1.125vw, 1rem);
  box-sizing: border-box;

  &:hover {
    background: #5a67d8;
    transform: translateY(-2px);
  }

  /* Responsive sizing for different desktop resolutions */
  @media (min-width: 1920px) {
    padding: clamp(0.75rem, 1.25vw, 1.25rem) clamp(1.5rem, 2.5vw, 2rem);
    border-radius: clamp(0.5rem, 0.75vw, 0.75rem);
    font-size: clamp(1rem, 1.25vw, 1.125rem);
  }

  @media (min-width: 1440px) and (max-width: 1919px) {
    padding: clamp(0.6875rem, 1.125vw, 1.125rem) clamp(1.375rem, 2.25vw, 1.875rem);
    border-radius: clamp(0.5rem, 0.75vw, 0.75rem);
    font-size: clamp(0.9375rem, 1.125vw, 1.0625rem);
  }

  @media (min-width: 1366px) and (max-width: 1439px) {
    padding: clamp(0.625rem, 1vw, 1rem) clamp(1.25rem, 2vw, 1.75rem);
    border-radius: clamp(0.4375rem, 0.625vw, 0.625rem);
    font-size: clamp(0.9375rem, 1.125vw, 1.0625rem);
  }

  @media (min-width: 1280px) and (max-width: 1365px) {
    padding: clamp(0.5625rem, 0.875vw, 0.9375rem) clamp(1.125rem, 1.75vw, 1.625rem);
    border-radius: clamp(0.4375rem, 0.625vw, 0.625rem);
    font-size: clamp(0.875rem, 1vw, 1rem);
  }

  @media (min-width: 1024px) and (max-width: 1279px) {
    padding: clamp(0.5rem, 0.75vw, 0.875rem) clamp(1rem, 1.5vw, 1.5rem);
    border-radius: clamp(0.375rem, 0.5vw, 0.5rem);
    font-size: clamp(0.875rem, 1vw, 1rem);
  }

  @media (max-width: 1023px) {
    padding: clamp(0.4375rem, 0.625vw, 0.75rem) clamp(0.875rem, 1.25vw, 1.375rem);
    border-radius: clamp(0.375rem, 0.5vw, 0.5rem);
    font-size: clamp(0.8125rem, 0.9375vw, 0.9375rem);
  }
  
  @media (max-width: 768px) {
    padding: clamp(0.375rem, 0.5vw, 0.625rem) clamp(0.75rem, 1vw, 1.25rem);
    border-radius: clamp(0.375rem, 0.5vw, 0.5rem);
    font-size: clamp(0.75rem, 0.875vw, 0.875rem);
  }
`;

const Error = () => {
    return (
        <ErrorContainer>
            <ErrorCode>404</ErrorCode>
            <ErrorMessage>Page Not Found</ErrorMessage>
            <ErrorDescription>
                The page you are looking for might have been removed, had its name changed,
                or is temporarily unavailable.
            </ErrorDescription>
            <HomeLink to="/">Return to Homepage</HomeLink>
        </ErrorContainer>
    );
};

export default Error;
